import request from '@/utils/request'

export interface MusicReportInfo {
  single_loop_artist_name: string
  first_favorite_dt: number
  first_favorite_song_name: string
  first_favorite_artist_name: string
  early_morning_ts: number
  early_morning_song_name: string
  early_morning_artist_name: string
  late_night_ts: number
  late_night_song_name: string
  late_night_artist_name: string
  single_loop_dt: number
  single_loop_song_name: string
  single_loop_play_cnt: number
  first_use_lp_dt: string
  explor_month: number
  explor_month_song_ctd: number
  monthly_hit: string[]
  top_1_playlist_name: string
  top_1_playlist_minutes: number
  total_play_song_ctd: number
  top_1_song_play_cnt: number
  top_1_song_artist_name: string
  top_1_artist_play_day_cnt: number
  top_1_artist_play_minutes: number
  explor_artist_name: string
  explor_artist_song_ctd: number
  top_n_artist: string[]
  total_play_minutes: number
  total_play_day_cnt: number
  top_n_song_name: string[]
  first_play_ts: number
  device_id: string
  new_region: string
  total_play_time: number
  total_play_count: number
  top_name: string[]
  top_artist: string[]
  // 时间段
  time_frame: number
  time_frame_song_name: string
  time_frame_play_count: number
  // 单曲循环最多次的歌曲
  // 暂时没用上
  top_single_loop: string[]
  top_play_list: string[]
  // 年度歌手
  artist_over_year: string
  artist_over_year_days: number
  artist_over_year_mins: number
  artist_of_year: string
  artist_of_year_days: number
  artist_of_year_mins: number
  last_played_song_name_1yr: string
  first_played_song_name: string
  first_played_song_dt: number
  valentine_artist_name: string
  valentine_song_name: string
  first_favorite_song_name_1yr: string
  first_favorite_dt_1yr: number
  // 音量增强
  volume_boost_dt: number
  volume_boost_song_name: string
  volume_boost_volume: number
  longest_play_dt: number
  longest_play_mins: number
  longest_play_first_song_name: string
  longest_play_last_song_name: string
}

export interface MusicRankInfo {
  country: string
  region: string
  percentages: {
    p99: number
    p95: number
    p90: number
    p75: number
    p50: number
    p30: number
  }
  type: 'MONTHLY' | 'WEEKLY'
  dt: string
}

const getMusicReport = async ({
  deviceId,
  type,
  dt,
}: {
  deviceId: string
  type: 'weekly' | 'monthly' | 'yearly'
  dt: string
}) => {
  const key = `${type}|${deviceId}|${dt}`
  if (localStorage[key]) return JSON.parse(localStorage[key]) as MusicReportInfo

  let res = await request.get<any, MusicReportInfo>(
    '/bc-user-growth-ops-server/music/report',
    {
      params: {
        device_id: deviceId,
        type,
        dt,
      },
    }
  )

  // 查不到数据就给默认数据
  if (res === null) {
    // @ts-ignore
    res = {
      device_id: deviceId,
      new_region: '',
      total_play_time: 0,
      total_play_count: 0,
      top_name: [],
      top_artist: [],
      time_frame: -1,
      time_frame_song_name: '',
      time_frame_play_count: 0,
      top_single_loop: [],
      top_play_list: [],
      total_play_day_cnt: 0,
    }
  } else {
    // 只有有数据的时候才缓存
    localStorage[key] = JSON.stringify(res)
  }

  return res
}

const getMusicRank = (params: { region: string; type: 'weekly' | 'monthly' }) =>
  request.get<any, MusicRankInfo>('/bc-user-growth-ops-server/music/rank', {
    params,
  })

const API = {
  getMusicReport,
  getMusicRank,
}

export default API
